export const GET_COLLECTION = '/users'
export const POST = '/users'